import { gql } from "urql";
export const CreatePublicUploadFilePresignedUrlMutation = gql `
    mutation CreatePublicUploadFilePresignedUrl(
        $input: PublicUploadFilePresignedUrlInput!
    ) {
        files {
            createPublicUploadFilePresignedUrl(input: $input) {
                presignedUrl
                caregiverId
                patientId
            }
        }
    }
`;
export const CreatePublicFileRecordMutation = gql `
    mutation CreatePublicFileRecord($input: CreatePublicFileInput!) {
        files {
            createPublicFileRecord(input: $input) {
                success
                error
            }
        }
    }
`;
